import { Box, Container } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

import { PageFooter } from './page-footer';
import { PageHeader } from './page-header';
import { SidebarDrawer } from './sidebar-drawer';

export function Layout() {
  return (
    <Box
      minH="var(--app-viewport-height)"
      h="var(--app-viewport-height)"
      maxH="var(--app-viewport-height)"
      bg="bg.subtle"
      display="flex"
      flexDirection="column"
      overflow="hidden"
    >
      <SidebarDrawer hideFixedToggle />
      <Box flexShrink={0}>
        <PageHeader />
      </Box>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        minHeight={0}
        overflowY="auto"
        style={{ backgroundColor: 'var(--background-base-color)' }}
      >
        <Container
          maxW="7xl"
          p={0}
          flex={1}
          display="flex"
          flexDirection="column"
          minHeight={0}
        >
          <Outlet />
        </Container>
      </Box>
      <PageFooter />
    </Box>
  );
}
